// 登录token key
export const TOKEN_KEY = 'SignInToken';

//顶部tabbar
export const SIGNIN_TOP_BAR_HEIGHT = 'signInTopBarHeight';
